<template>
    <div class="fast_preview_mem">
        <div class="bd-callout bd-callout-info shadow">
            <div class="row">
                <div class="col-6 col-xs-12 pr-5">
                    <div class="row mem_fil  border-bottom border-primary pb-3" v-if="item.pre_text.length > 0">
                        <div class="col-2">Преамбула</div>
                        <div class="col-10" v-html="item.pre_text"></div>
                    </div>

                    <div class="row mem_fil  border-bottom border-primary pb-3" v-if="item.problem.length > 0">
                        <div class="col-2">Проблема</div>
                        <div class="col-10" v-html="item.problem"></div>
                    </div>

                    <div class="row mem_fil " v-if="item.result.length > 0">
                        <div class="col-2">Запропоноване рішення</div>
                        <div class="col-10" v-html="item.result"></div>
                    </div>
                </div>

                <div class="col-6 col-xs-12 border-left pl-5 pr-5">
                    <div class="adjust_block" v-if="item.adjusts.length > 0">
                        <h4 class="card-title">Погодження</h4>
                        <div class="user_block">
                            <user_block :key="user.user_id" :user="user" class="mt-2" v-for="user in item.adjusts"></user_block>
                        </div>
                    </div>

                    <h4 class="card-title">Видалення</h4>
                    <div class="user_block">
                        <user_block :key="item.remover.id + '_remover'" :user="item.remover" ></user_block>
                    </div>

                </div>
            </div>
        </div>
        
    </div>
</template>

<script>

    import user_block from "../../../../shared/user/user_block/user_block.vue";
    export default {
        name: "fast_preview",

        components : {
            user_block
        },

        props: {
            item: {
                type: Object,
                required :true
            },
        }

    }
</script>

<style scoped>
    .bd-callout {
        border-radius: 0;
    }
</style>
